export const menus = [
	{
		name: 'আমাদের সম্পর্কে',
		link: 'About'
	},
	{
		name: 'যোগাযোগ',
		link: 'Contact'
	},
]